'use client'

import { MouseEvent } from 'react'
import { useRouter } from 'next/navigation'
import Button from '@dustin-web/microsite-components/src/button'
import { useFeatureFlag } from '@dustin-web/microsite-data/src/feature-flags/client'
import {
  useAccordionScroll,
  openAccordionItem,
} from '@dustin-web/microsite-components/src/accordion-group'

import { ACCORDION_AB_TEST_FLAG, TABORDION_CONTAINER_ID } from '../../product-page.constants'

type Props = {
  href: string
  text: string
  className?: string
}

const itemValueFromHref = (href: string) => {
  const query = href.includes('?') ? href.slice(href.indexOf('?')) : ''
  return new URLSearchParams(query).get('tab') ?? ''
}

const ScrollToTabsButton = ({ href, text, className }: Props) => {
  const { enabled: accordionsEnabled } = useFeatureFlag(ACCORDION_AB_TEST_FLAG)
  const { scrollToItem, scrollToContainer } = useAccordionScroll()
  const router = useRouter()

  if (accordionsEnabled) {
    const handleAccordionClick = () => {
      const value = itemValueFromHref(href)
      openAccordionItem(value)
      scrollToItem(value)
    }

    return <Button className={className} onClick={handleAccordionClick} text={text} />
  }

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    router.push(href, { scroll: false })
    scrollToContainer(TABORDION_CONTAINER_ID)
  }

  return <Button link className={className} onClick={handleClick} href={href} text={text} />
}

export default ScrollToTabsButton
